export default {
  purchasing: {
    title: '輸出手続きの流れ',
    steps: [
      {
        number: '01',
        title: 'ご発注仕様の明確化',
        description:
          '購入を希望する化学品、必要なスペック、月間使用量（プロジェクトに必要な推定数量）、希望価格、希望する納品スケジュールなどを明確にすることから始めてください。また、お客様の国に輸入するために必要な許可証・認可を取得していることをご確認ください。',
        expandedTitle: '日本製化学品を購入する理由',
        expandedParagraphs: [
          '価格とスペックだけを考慮すると、日本の化学品は高コストに見えるかもしれません。そのため、これらの製品がすべてのユーザーに最適な選択肢とは限りません。',
          'しかし、大真株式会社は本物の製品のみを提供しており、最初からその高い機能性、均一な品質、独自の技術、使いやすさ、そしてその高いコストに見合ったユーザー志向のサービスを実感いただけます。',
          '私たちの目標は、高品質な日本の化学品製品を必要なユーザーに供給することで、世界をより複雑でなく、より透明で、より豊かな場所にすることです。',
        ],
      },
      {
        number: '02',
        title: 'ご相談',
        description:
          '発注が確定したら、ご連絡ください。リクエストを確認し、ご要件に基づいた提案をします。最適なソリューションを提案するために、状況に関する情報（プロジェクトの性質、注文する製品の用途、最終製品など）および見積もりを求める目的（コスト削減、品質向上、二重仕入れ先戦略など）をお知らせください。',
        expandedTitle: '海外化学品サプライヤーの選び方',
        comparisonLocal: {
          title: '化学品専門商社のメリット',
          items: [
            '化学業界への専門化により、化学メーカーとの強いつながり。',
            '人事異動が少なく、担当者が継続的に対応。',
            '化学業界への専門化により、リクエストに迅速に対応可能。',
            '個人の裁量が大きく、クライアントのニーズに柔軟に対応。',
          ],
        },
        comparisonGlobalCons: {
          title: '総合商社系化学品販社のデメリット',
          items: [
            '専門性の欠如により、知識やスキルの質にばらつきがある。',
            '人事異動が多く、担当者が頻繁に変わる。',
            '多分野に注力するため、クライアントのリクエストへの対応が遅れることがある。',
            '会社方針・ガイドラインの優先により、クライアントのニーズが後回しになることがある。',
          ],
        },
        comparisonGlobalPros: {
          title: '総合商社系化学品販社のメリット',
          items: [
            '知名度が高く、交渉の最初から安心感がある。',
            '社内の多様な知識により、カップ麺からロケットまで幅広い製品を効率的に取り扱える。',
            '数億ドル規模のプロジェクトを処理できる大規模な業務体制。',
            '資源開発、M&Aなど、非製品面の取り扱いも可能。',
            '海外支店や非日本メーカーからも製品を提供可能。',
          ],
        },
        comparisonLocalCons: {
          title: '化学品専門商社のデメリット',
          items: [
            '知名度が低く、最初は取引に不安を感じるクライアントもいる。',
            '化学業界への特化により、専門外の情報に不慣れな場合がある。',
            '規模が小さく、大規模なプロジェクトへの対応が難しい場合がある。',
            '専門外の業務には対応できないことがある。',
            '製造元が日本に拠点を置かない場合、海外支店からの製品提供はできない。',
          ],
        },
      },
      {
        number: '03',
        title: 'ご協議',
        description:
          '当社の製品提供はCIF（運賃保険料込）またはCFR（運賃込）条件に基づいています。この段階で、HSコードを通じてお客様の国の輸入関税を確認するようお願いします。また、通関業者に輸入手続きの総コストを確認し、取引によって発生する最終的なコストを計算してください。',
        linkText: '輸出入用語について',
        linkPath: '/import-export-terms',
      },
      {
        number: '04',
        title: 'サンプルテスト',
        description:
          'スペックシートと見積書に基づく購入コストが確定・合意された後、サンプルテストにより製品の品質を確認する機会があります。通常は50gから1kgのサンプルをご提供しますが、サンプルの入手可能性は製品と状況によって異なります。',
      },
      {
        number: '05',
        title: 'トライアルオーダー',
        description:
          'サンプルテストが成功した場合、安全のため、大量注文の前に製品の最小単位（200kgドラム缶など）を最初に購入することをお勧めします。これにより、実際の使用環境で最終的な品質確認を行うことができます。',
      },
      {
        number: '06',
        title: '初回契約',
        description:
          'トライアルオーダー終了後、より大きな購入を希望される場合は、メールで注文確認書をお送りください。当社が売買契約書を作成し、受領後に最初の契約金をお支払いいただきます。契約オプションには、単一出荷の短期契約から年間契約まであります。最初は短期契約から始め、当社のサービスと製品の品質を確認した後、長期契約に移行することをお勧めします。契約が確定した後はキャンセルできません。注文確認書を提出する前に、購入予定製品の輸入規制と輸入申請の状況を確認してください。',
      },
      {
        number: '07',
        title: '初回出荷',
        description:
          '製品は契約条件に従って出荷され、輸入手続き完了後、通関業者によってお客様の施設に配送されます。',
        subSteps: [
          {
            title: '輸入通関手配',
            description:
              '指定した通関業者が輸入通関の手配・準備を行います。当社が提供する船積書類とお客様から取得した情報をもとに、製品の申告価格と適用されるHSコードを特定し、税関に輸入申告書を提出します。貨物が輸入通関以外の法令に基づく特別な許可を必要とする場合は、事前に必要な申請書を準備し、この段階で関係官庁に提出する必要があります。',
          },
          {
            title: '輸入申告',
            description:
              '製品が指定港に到着したら、通関業者が税関に輸入申告を行います。税関職員は現地の規制に従い、書類審査と貨物検査を実施します。検査完了後、必要に応じて追加の申請手続きを行います。',
          },
          {
            title: '輸入許可',
            description:
              '審査・検査が完了し、関税・消費税が納付された後、輸入許可が下ります。他の規制に基づく追加申請が必要な場合は、その承認が得られるまで輸入許可は発行されません。',
          },
          {
            title: 'デリバリーオーダーの取得',
            description:
              '海運会社からデリバリーオーダー（D/O）が発行されると貨物が引き渡されます。海運会社に現地チャージを支払い、船荷証券（B/L）原本とD/Oを交換します。',
          },
          {
            title: '配送手配',
            description:
              '貨物はコンテナドレージまたはトラックでお客様の施設に配送されます。海運会社のコンテナヤード（CY）またはコンテナフレートステーション（CFS）で貨物を受け取る際は、D/Oと輸入許可証をCY/CFSに提出してください。CY/CFSはD/Oと許可証の内容を確認した上で配送を完了します。',
          },
        ],
        closingNote: 'この手続きは国によって異なる場合がありますので、事前に現地の規制をご確認ください。',
        linkText: '化学品貿易情報を見る',
        linkPath: '/chemical-trade-info',
      },
      {
        number: '08',
        title: 'フィードバック',
        description:
          '今後の出荷の改善に役立てるため、製品とサービスの品質についてフィードバックをいただければ幸いです。',
      },
    ],
    cta: {
      title: '始める準備はできていますか？',
      description: '今すぐご連絡いただき、大真株式会社との化学品調達の旅を始めましょう。',
      btn: '今すぐお問い合わせ',
    },
  },
};
